import React from 'react';

const ActionButtons = ({ onSave, saveText = 'Сохранить' }) => {
  return (
    <div className="action-bar">
      <button
        type="button"
        onClick={onSave}
        className="primary-action compact"
      >
        {saveText}
      </button>
    </div>
  );
};

export default ActionButtons;
